import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageFakeInfo } from './voyageFakeInfo-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import type { IVoyageSystemData } from './voyageSystemsData'
import { voyageSystemsData } from './voyageSystemsData-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import type { IVoyageTilemapPart } from './voyageTilemapPart'
import { voyageTilemapPart } from './voyageTilemapPart-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export interface IVoyageSystemState {
  key: string
  requestedInfo: boolean
  ammo: number
  nickname: string
  frozenCrewName: string
  data: IVoyageSystemData
  id: number
}

export const createSystemState = (
  tile: IVoyageTilemapPart,
  key: string,
  id: number,
) => {
  let data = voyageSystemsData.find(tile)
  tile.system = {
    key,
    requestedInfo: false,
    ammo: 0,
    nickname: '',
    frozenCrewName: '',
    data,
    id,
  }
}

export const init = (tile: IVoyageTilemapPart, key: string, id: number) => {
  // console.log('init system')
  createSystemState(tile, key, id)
  assert.notNil(tile.system)
  if (voyageWebsockets.getIsHost()) {
    tile.system.nickname = voyageFakeInfo.genFakeProjectName()
  }
  tile.system.ammo = tile.system.data.startsWithAmmo

  if (tile.system.data.onCreate) {
    tile.system.data.onCreate(tile.system, tile.text3, tile)
  }

  let sys = tile.system
  // console.log('got a system!', c.system.nickname)
  // console.log('sys init', key, id)
  if (sys.data.abbv && tile.text) {
    stevieTexts2.setText(tile.text, sys.data.abbv)
    if (sys.data.abbv.length === 1) {
      stevieTexts2.moveTo(
        tile.text,
        tile.x + 2 + sys.data.abbvXAdjust,
        tile.y + 2,
      )
    }
    if (sys.data.abbv.length === 2) {
      stevieTexts2.moveTo(
        tile.text,
        tile.x - 6 + sys.data.abbvXAdjust,
        tile.y + 2,
      )
    }
  }
  if (sys.data.killImage) {
    if (tile.image3) {
      tile.image3.destroy() //= false
      tile.image3 = null
    }
  }
  if (sys.data.frame) {
    if (tile.text) {
      stevieTexts2.setText(tile.text, '')
    }
    voyageTilemapPart.setSystemImage(tile, sys.data.frame, sys.data.tint)
  }
}

export function findSystem(name: string) {
  return voyageTilemap.getSystemByKey(name)
}

export function useSystem(obj: IVoyageCrew, tCur: IVoyageTilemapPart) {
  if (tCur.system) {
    if (!obj.isPassedOut) {
      //} || tCur.system.data.canUseWhilePassedOut) {
      tCur.system.data.crewUpdate(obj)
    }
  }
}

const phrases = [
  'No power',
  'Not responding',
  'Agh!',
  'Stupid machine',
  'Someone fix the reactor',
]
export function testNoPower(obj: IVoyageCrew) {
  let status = voyageGameStatus.get()
  if (status.power > 5) {
    return false
  }
  if (rando.chance(0.25)) {
    voyageCrew.say(obj, rando.sample(phrases))
  }
  return true
}
